<template>
  <div class="kopf" :class="{ 'bg-turkis': einkauf }">
    <div class="container-fluid">
      <!--  <slide width="400">
        <hr />
        <router-link :to="{ name: 'Startseite' }">
          <span> <i class="icon-ERP fs-30 mr-3"></i> Startseite </span>
        </router-link>
        <span class="bm-headline">CRM</span>
        <nav class="bm-item-list">
          <router-link :to="{ name: 'Geschäftspartnerliste' }">
            <span> <i class="fas fa-users mr-3 fs-30"></i>Person </span>
          </router-link>
          <nav class="bm-item-list">
            <router-link :to="{ name: 'Studierende' }">
              <span> <i class="icon-Customer mr-3 fs-30"></i>Student </span>
            </router-link>
            <router-link :to="{ name: 'Dozenten HF' }">
              <span> <i class="fas fa-book fs-30 mr-3"></i>Dozent </span>
            </router-link>
          </nav>
          <router-link to="/crm/adresse">
            <span> <i class="icon-Quote fs-30 mr-3"></i>Adresse </span>
          </router-link>
          <router-link to="/crm/Login">
            <span> <i class="icon-Basket fs-30 mr-3"></i>Login </span>
          </router-link>
        </nav>
        <span class="bm-headline">FINANZEN</span>
        <nav class="bm-item-list">
          <router-link to="/finanzen/debitoren">
            <span>
              <i class="icon-Inbox-Special fs-30 mr-3"></i>Debitoren
            </span>
          </router-link>
          <router-link to="/finanzen/beleg">
            <span> <i class="icon-Checkliste-2 fs-30 mr-3"></i>Beleg </span>
          </router-link>
          <router-link to="/finanzen/buchung">
            <span> <i class="icon-Lieferung fs-30 mr-3"></i>Buchung </span>
          </router-link>
          <router-link to="/finanzen/zahlungseingang">
            <span>
              <i class="icon-Invoice fs-30 mr-3"></i>Zahlungseingang
            </span>
          </router-link>
          <router-link to="/finanzen/mahnlauf">
            <span> <i class="icon-Invoice fs-30 mr-3"></i>Mahnlauf </span>
          </router-link>
          <router-link to="/finanzen/mahnungen">
            <span>
              <i class="icon-Delivery-Slip fs-30 mr-3"></i>Mahnungen
            </span>
          </router-link>
          <router-link to="/finanzen/vorauszahlung">
            <span> <i class="fas fa-book fs-30 mr-3"></i>Vorauszahlung </span>
          </router-link>
        </nav>
        <span class="bm-headline">Artikel</span>
        <nav class="bm-item-list">
          <router-link :to="{ name: 'artikelliste' }">
            <span> <i class="icon-Paket fs-30 mr-3"></i>Artikel </span>
          </router-link>
          <nav v-if="artikeltypen" class="bm-item-list">
            <router-link
              v-for="at in artikeltypen"
              :key="at.id"
              :to="`/stammdaten/artikelliste/${at.id}`"
            >
              <span>
                <i class="fs-30 mr-3" :class="[at.icon]"></i>
                {{ at.name }}
              </span>
            </router-link>
          </nav>
        </nav>
        <span class="bm-headline">RESSOURCEN</span>
        <nav class="bm-item-list">
          <a href="/ressourcen/termin">
            <span> <i class="icon-Inbox mr-3 fs-30"></i>Termin </span>
          </a>

          <a href="/ressourcen/regelstundenplan">
            <span>
              <i class="icon-Inbox-Special-2 mr-3 fs-30"></i>Regelstundenplan
            </span>
          </a>
          <a href="/ressourcen/regeltermin">
            <span>
              <i class="icon-Ear-Protection mr-3 fs-30"></i>Regeltermin
            </span>
          </a>
        </nav>
      </slide>
     <div class="left-buttons" style="z-index: 5">
        <div class="navbar-button">
          <a href="/erp/" title="HOME" class="none-decoration">
            <i class="fad fa-lg fa-home" aria-hidden="true"></i>
            <span>HOME</span>
          </a>
        </div>
        <div class="navbar-button">
          <div class="clickable" @click="$router.go(-1)">
            <i class="icon-Chevron-left" aria-hidden="true"></i>
            <span>Zurück</span>
          </div>
        </div>
        <div class="navbar-button">
          <div class="clickable" @click="$router.go(1)">
            <i class="icon-Chevron-right" aria-hidden="true"></i>
            <span>Vor</span>
          </div>
        </div>
      </div> -->
      <span class="HeaderTitle text-center">Arvea Universe Calculator</span>
      <div class="left-buttons">
        <div>
          <button class="btn btn-primary mt-3 mr-2" @click="oeffneAlertModal">
            Calculate
          </button>
        </div>
      </div>
      <div class="right-buttons">
        <div class="navbar-button">
          <a href="#" onclick="window.location.reload(true);">
            <i class="icon-Refresh" aria-hidden="false"></i>
            <span>Refresh</span>
          </a>
        </div>
    <!--    <div class="navbar-button">
            <a href="#" @click="oeffneLogoutModal">
              <i class="fa fa-sign-out" aria-hidden="false"></i>
              <span>Logout</span>
            </a>
          </div> -->

        <!--      <button type="navbar-button" class="btn btn-default btn-sm" @click="logout">
          <i class="bi bi-box-arrow-right"></i> <span>Log out</span>
        </button>
       <div class="navbar-button" v-if="berechtigungen.g_einstellungen.read">
          <router-link to="/einstellungen/dashboard">
            <i class="fad fa-sliders-v-square"></i>
            <span>Einstellungen</span>
          </router-link>
        </div> 

        <div class="usersign" style="padding-left: 10px; top: 11px">
          <a href="/user" title="Profil" class="none-decoration">
            <i
              class="icon-Profil"
              style="font-size: 40px"
              aria-hidden="true"
            ></i>
            <span>{{ name }}</span>
          </a> 
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import Slide from "@/components/Navigation/Menu/Slide";
import Api from "@/Api";

import axios from "axios";

import server from "../server";
export default {
  name: "Navbar",
  components: {
    //  Slide,
  },
  props: {
    title: { type: String, required: false, default: "" },
    icon: { type: String, default: null },
    einkauf: { type: Boolean, default: false },
    finanzen: { type: Boolean, default: false },
    erinnerungConfig: {
      type: Object,
      default: () => {
        return { url: "", titel: "" };
      },
    },
  },
  store,
  computed: {
    name() {
      return this.$store ? this.$store.getters.name : "";
    },
    artikeltypen() {
      return this.$store.state.artikeltypen;
    },
    /*  logoutUrl() {
      if(process.env.NODE_ENV === "development") {
        return `${server.url}/logout/`
      } else {
        return "/logout/"
      }
    }*/
  },
  methods: {
    oeffneAlertModal() {
      this.$parent.erstelleListenFuerModal();
      this.$parent.oeffneAlertModal();
    },
    oeffneLogoutModal() {
      this.$parent.logout();
    }
    /*logout(){

axios.post(this.logoutUrl)
}*/
  },
};
</script>

<style lang="scss">
.bm-item-list {
  margin-left: 5%;
}
</style>
